import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "./hilight.css";

import { Navigation, Pagination, Autoplay } from "swiper/modules";

import oilfree from "../assets/menu/hilightpoins/oilfree.png";
import instantcooking from "../assets/menu/hilightpoins/instantCooking.png";
import protien from "../assets/menu/hilightpoins/protien.png";
import chines from "../assets/menu/hilightpoins/chinese.png";
import variety from "../assets/menu/hilightpoins/variety.png";
import tailored from "../assets/menu/hilightpoins/tailored.png";
import subscribe from "../assets/menu/hilightpoins/subscribe.png";
import { useNavigate } from "react-router-dom";

const SwiperSlideComponent = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/subscription");
  };
  return (
    <div className="swiper-containerfoodmenu">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
      >
        {/* Slides */}
        <SwiperSlide>
          <div className="hilightdivmenu" onClick={() => handleClick()}>
            <img src={oilfree} alt="oilfree" loading="lazy" />
            <p> Bhookr meals are mostly oil free meals</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="hilightdivmenu" onClick={() => handleClick()}>
            <img
              src={instantcooking}
              alt="instantcooking"
              className="h-[100%]"
              loading="lazy"
            />

            <p>Cooked instantly without storing</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="hilightdivmenu" onClick={() => handleClick()}>
            <img src={protien} alt="protien" loading="lazy" />
            <p>Every meal contains 25gm-50gm of protien</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="hilightdivmenu" onClick={() => handleClick()}>
            <img src={chines} alt="chines" loading="lazy" />
            <p>
              Bhookr works on multicusine kitchen model
              Indian/Continental/chinese
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="hilightdivmenu" onClick={() => handleClick()}>
            <img src={variety} alt="variety" loading="lazy" />
            <p>
              Our team tries to provide different varieties with great taste and
              low oil consumption
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="hilightdivmenu" onClick={() => handleClick()}>
            <img src={tailored} alt="tailored" loading="lazy" />
            <p>Food is tailored according to various needs</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="hilightdivmenu" onClick={() => handleClick()}>
            <img src={subscribe} alt="subscribe" loading="lazy" />
            <p>
              Discover protein-packed meals, tailored plans, and exclusive
              updates!
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default SwiperSlideComponent;
